var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "category-menu-btn--image",
      attrs: {
        width: "800",
        height: "800",
        viewBox: "0 0 800 800",
        version: "1.1",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": _vm.alt
      }
    },
    [
      _c("image", {
        key: _vm.color,
        staticClass: "category-menu-btn--image-element",
        attrs: {
          width: "100%",
          height: "100%",
          "xlink:href": _vm.url,
          filter: _vm.imageFilter
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-073efe2a", { render: render, staticRenderFns: staticRenderFns })
  }
}